import React from 'react';
import cn from 'classnames';
import LitView from '../../../DeviationViews/Dumbo/Literature';
import { Props } from '../InlineView';

import s from './Literature.scss';

const JournalView: React.FC<Props> = props => {
  const { deviation, width, height } = props;

  return (
    <div className={cn(s['root'])} style={{ width: width }}>
      <LitView width={width} height={height} deviation={deviation} />
    </div>
  );
};
JournalView.displayName = 'JournalView';

export default JournalView;
